import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function StudioPage({ title, kicker, body, testid = "studio-page", centered = false }) {
  // Founder plain-ink 2026-08-23: About / Mission / Contact are center-aligned.
  // Other studio pages (Terms / Privacy / Legal / What We Do) keep left-align
  // because they carry structured lists and long-form legal copy.
  const align = centered ? "text-center" : "";
  const kickerAlign = centered ? "text-center" : "";
  const backAlign = centered ? "text-center" : "";
  return (
    <Layout>
      <section
        data-testid={testid}
        className="relative pt-32 pb-32 min-h-[80vh]"
      >
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[500px] opacity-[0.07] blur-3xl"
               style={{ background: "radial-gradient(circle,#ff5a00,transparent 60%)" }} />
        </div>
        <div className="relative z-10 max-w-[900px] mx-auto px-6 sm:px-10">
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className={`font-mono text-[11px] uppercase tracking-[0.45em] text-[#ff5a00] ${kickerAlign}`}
          >
            {kicker}
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.05, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`${testid}-headline`}
            className={`font-display uppercase leading-[0.92] mt-6 text-[#ededed] ${align}`}
            style={{ fontSize: "clamp(2.75rem, 7vw, 5rem)", letterSpacing: "-0.005em" }}
          >
            {title}
          </motion.h1>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className={`prose prose-invert prose-lg mt-10 max-w-none font-body text-[#a1a1aa] leading-relaxed ${align}`}
          >
            {body}
          </motion.div>
          <p className={`font-mono text-[10px] uppercase tracking-[0.32em] text-[#52525b] mt-16 ${backAlign}`}>
            <Link to="/" className="text-[#ff5a00] hover:text-[#ff8f00]">← Back to the forge</Link>
          </p>
        </div>
      </section>
    </Layout>
  );
}
